import Game3 from './Game3';
export default Game3;


// WEBPACK FOOTER //
// ./src/containers/Game3/index.js